import hamburger, {
  createCaretIcon,
} from '../components/hamburger/hamburger.mjs';
import navigationMobileDrawer from '../components/navigation-mobile-drawer/navigation-mobile-drawer.mjs';
import {
  navigationPosition,
  navigationPreset,
} from './assets/navigation-position.mjs';
import {pageLayout} from './assets/page-layout.mjs';
import fadein from '../components/animation/fadein/fadein.mjs';
import cm4allNavigationTransition from './assets/navigation-transition.mjs';
import './smooth-scrolling.mjs';

document.addEventListener('DOMContentLoaded', () => {
  hamburger();
  navigationMobileDrawer();
  navigationPosition();
  navigationPreset();
  pageLayout();
  cm4allNavigationTransition();
  createCaretIcon(
    '.cm4all-theme-navigation-mobile-drawer__menu  .menu-item-has-children',
    true
  );
  createCaretIcon(
    '.cm4all-theme-navigation--desktop .menu-item-has-children > a',
    false,
    null,
    'beforeend'
  );

  // only fire transition after document is completly loaded
  window.onload = () => {
    if (document.body.classList.contains('cm4all-theme-stop-transition')) {
      document.body.classList.remove('cm4all-theme-stop-transition');
    }
  };

  fadein();

  window.top.addEventListener('resize', function () {
    navigationMobileDrawer();
    navigationPreset();
  });

  document.documentElement.addEventListener('cm4all-theme-settings', () => {
    navigationPosition();
    navigationPreset();
  });
});

if (window.top.wp?.customize) {
  window.top.wp.customize.previewedDevice.bind(function (newDevice) {
    navigationPreset(newDevice);
  });
}
